export enum SortOrder {
    ASC = 'ASC',
    DESC = 'DESC',
}


export enum PathNames {
    BITACORA = 'bitacora',
    BITACORA_MASIVE = 'bitacora-masive',
    SERVICES = 'services'
}


export enum ExcludedColumns {
    DISPONIBLE = 'disponible',
}